import React, { useEffect, useState } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { SelectChangeEvent } from '@mui/material/Select';
import { MultiselectProps } from '../types/types';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Multiselect: React.FC<MultiselectProps> = ({
  allModules,
  onChange,
  editTemp,
  selectedTemplateModules,
  templateId
}) => {
  const [selectedModules, setSelectedModules] = useState<number[]>([]);
  const [valueChange, setValueChange] = useState(false)
  // Normalize to array of numbers only
  const normalizeToNumberArray = (
    val: string | number | Array<string | number>
  ): number[] => {
    const arr = Array.isArray(val) ? val : [val];
    return arr
      .map((v) => (typeof v === 'string' ? parseInt(v, 10) : v))
      .filter((v): v is number => !isNaN(v));
  };

  useEffect(() =>{
    if(editTemp && templateId){
      setValueChange(false)
    }

  },[editTemp, templateId])

  useEffect(() => {
    if (editTemp && selectedTemplateModules && !valueChange) {
      const normalized = normalizeToNumberArray(selectedTemplateModules);
      setSelectedModules(normalized);
      onChange(normalized);
    }
  }, [editTemp, selectedTemplateModules]);

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value as (string | number)[];
    const numericValues = normalizeToNumberArray(value);
    setSelectedModules(numericValues);
    setValueChange(true)
    onChange(numericValues);
  };

  return (
    <FormControl
      variant="standard"
      classes={{ root: 'multiselecte-wrapper' }}
      sx={{ m: 1, width: '100%' }}
    >
      <Select
        multiple
        value={selectedModules}
        onChange={handleChange}
        variant="standard"
        input={<OutlinedInput label="Module" />}
        renderValue={(selected: any) => {
          const selectedLabels = allModules
            .filter((mod: any) => selected.includes(mod.value))
            .map((mod: any) => mod.label);
        
          return selectedLabels.join(', ');
        }}        
        MenuProps={MenuProps}
        classes={{
          root: 'template-details-inputs-mui',
          select: 'template-details-inputs-mui',
          outlined: 'outlined-mui-wrapper',
        }}
      >
        {Array.isArray(allModules) &&
          allModules.map((module) => (
            <MenuItem key={module.value} value={module.value}>
              <Checkbox checked={selectedModules.includes(Number(module.value))} />
              <ListItemText primary={module.label} />
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default Multiselect;
